import { IAudience } from "../../types/audience"

export enum AudiencesActionTypes {
  FETCH_AUDIENCES_LIST = "FETCH_AUDIENCES_LIST",
  FETCH_AUDIENCES_LIST_SUCCESS = "FETCH_AUDIENCES_LIST_SUCCESS",
  FETCH_AUDIENCES_LIST_ERROR = "FETCH_AUDIENCES_LIST_ERROR",
}

interface FetchAudiencesList {
  type: AudiencesActionTypes.FETCH_AUDIENCES_LIST
}

interface FetchAudiencesListSuccess {
  type: AudiencesActionTypes.FETCH_AUDIENCES_LIST_SUCCESS
  payload: IAudience[]
}

interface FetchAudiencesListError {
  type: AudiencesActionTypes.FETCH_AUDIENCES_LIST_ERROR
  payload: string
}

export type AudiencesAction =
  | FetchAudiencesList
  | FetchAudiencesListSuccess
  | FetchAudiencesListError

export interface AudiencesState {
  audiences: IAudience[]
  loaded: boolean
  error: string | null
}
